import { RootState } from '../types';

export const firebaseSelector = (state: RootState) => state.firebase
